import './ChartSkeleton.css'

export default function ChartSkeleton() {
  return (
    <div className="chart-skeleton skeleton" aria-hidden="true">
      <div className="skeleton-pulse chart-title" />
      <div className="skeleton-pulse chart-area" />
    </div>
  )
}
